import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Skeleton as SkeletonCore } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import cn from 'classnames';
import colors from '../../foundations/colors.module.scss';
import { getTestIds } from '../../utils/TestIds';
export const GetSkeletonTID = (parentTestId)=>getTestIds(parentTestId);
const useStyles = makeStyles({
    root: {
        backgroundColor: colors.dark100
    },
    text: {
        transformOrigin: 'unset',
        transform: 'unset',
        borderRadius: '4px',
        marginTop: 'unset',
        marginBottom: 'unset'
    },
    wave: {
        '&::after': {
            background: "linear-gradient(90deg, transparent, ".concat(colors.dark70, ", transparent);")
        }
    }
});
export function Skeleton(_0) {
    let { className, width, height, as = 'div', testId } = _0, rest = _object_without_properties(_0, [
        "className",
        "width",
        "height",
        "as",
        "testId"
    ]);
    const { SkeletonTID } = useMemo(()=>GetSkeletonTID(testId), [
        testId
    ]);
    const overrides = useStyles();
    return /*#__PURE__*/ _jsx(SkeletonCore, _object_spread({
        width: width,
        height: height,
        component: as,
        className: cn(overrides.root, overrides.text, overrides.wave, className),
        animation: "wave",
        variant: "text",
        "data-testid": SkeletonTID.Root()
    }, rest));
}
